<template>
  <iframe
    id="chat-iframe"
    loading="lazy"
    @load="handleChatWidget"
    @error="handleIframeError"
    src="/chattigo.html"
    v-if="shouldRenderIframe"
  ></iframe>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ChatIframe',
  data() {
    return {
      user: undefined,
      hasRendered: false,
      shouldRenderIframe: false
    }
  },
  watch: {
    mySession() {
      this.user = this.$session.get('cas_user')
      if (!this.hasRendered) this.processRender()
    },
    'mySession.email'(newEmail, oldEmail) {
      this.user = this.$session.get('cas_user')
      if (!!oldEmail && !!newEmail && oldEmail !== newEmail) this.processRender()
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession'
    })
  },
  mounted() {
    this.user = this.$session.get('cas_user')
    if (this.user) this.processRender()
  },
  methods: {
    processRender() {
      this.shouldRenderIframe = true
      this.handleChatWidget()
      this.hasRendered = true
    },
    handleChatWidget() {
      const iframe = document.getElementById('chat-iframe')
      if (iframe) {
        const checkWidgetScript = setInterval(() => {
          try {
            const scriptLoaded = iframe.contentDocument?.querySelector('#widget-chattigo')
            if (scriptLoaded) {
              clearInterval(checkWidgetScript)
              this.user?.user_access?.show_chat && !['/restore-password', '/recovery'].includes(this.$route?.path) ? this.showChatWidget(iframe) : this.hideChatWidget(iframe)
            } else {
              console.warn('Widget script not loaded yet, waiting...')
            }
          } catch (error) {
            console.error('Error checking widget script:', error)
            clearInterval(checkWidgetScript)
            this.hideChatWidget(iframe)
          }
        }, 50)

        setTimeout(() => {
          clearInterval(checkWidgetScript)
          if (!iframe.contentDocument?.querySelector('#widget-chattigo')) {
            console.error('Widget script failed to load')
            this.hideChatWidget(iframe)
          }
        }, 5000)
      }
    },
    handleIframeError() {
      const iframe = document.getElementById('chat-iframe')
      if (iframe) {
        console.error('Error al cargar el iframe, ocultándolo')
        this.hideChatWidget(iframe)
      }
    },
    showChatWidget(iframe) {
      let computedStylesImg = null
      const initializeWidget = () => {
        iframe.style.display = 'block'
        const widget = iframe.contentDocument?.querySelector('app-widget-root')
        if (widget) {
          widget.init()
          widget.setCustomContactId(this.user.email)
          setTimeout(() => {
            const btnOpen = iframe.contentDocument.querySelector('.chattigo-widget-trigger')
            const btnClose = iframe.contentDocument.querySelector('.chattigo-widget__close-icon')
            const btnDismiss = iframe.contentDocument.querySelector('.chattigo-icon-arrow-down')
            const conditionWelcome = iframe.contentDocument.querySelector('.chattigo-widget--welcome')
            if (!!btnOpen) {
              computedStylesImg = iframe.contentWindow.getComputedStyle(btnOpen)
            }
            iframe.style.opacity = 1
            const conditionButton = !!btnOpen && (!btnClose && !btnDismiss)
            iframe.style.width = conditionButton ? computedStylesImg?.width : '376px'
            iframe.style.height = conditionButton ? computedStylesImg?.height : '100%'
            iframe.style.maxHeight = conditionButton || !!conditionWelcome ? '500px' : '600px'
            iframe.style.maxWidth = '376px'
          }, 3000)
          const conditionsCss = () => {
            const conditionWelcome = iframe.contentDocument.querySelector('.chattigo-widget--welcome')
            const conditionEnding = iframe.contentDocument.querySelector('.chattigo-widget--ending')
            if (!!conditionEnding) {
              iframe.style.maxHeight = '475px'
            } else if (!!conditionWelcome) {
              iframe.style.maxHeight = '500px'
            } else {
              iframe.style.maxHeight = '600px'
            }
          }
          iframe.contentDocument.addEventListener('click', (e) => {
            const buttonsOpen = [
              '.chattigo-widget-trigger',
              '.chattigo-widget-trigger__logo'
            ]
            if (buttonsOpen.some(button => e.target.matches(button))) {
              iframe.style.width = '376px'
              iframe.style.height = '100%'
            }
            const buttons = [
              '.chattigo-icon-close',
              '.chattigo-widget__close-icon',
              '.chattigo-icon-arrow-down'
            ]
            if (buttons.some(button => e.target.matches(button))) {
              iframe.style.width = computedStylesImg?.width || '60px'
              iframe.style.height = computedStylesImg?.height || '60px'
            }
          })
          const observerOptions = {
            childList: true,
            subtree: true
          }
          const observer = new MutationObserver(conditionsCss)
          observer.observe(widget, observerOptions)
        }
      }
      const checkIframe = setInterval(() => {
        if (iframe.contentDocument) {
          clearInterval(checkIframe)
          initializeWidget()
        }
      }, 500)
    },
    hideChatWidget(iframe) {
      iframe.style.display = 'none'
      const widget = iframe.contentDocument?.querySelector('app-widget-root')
      if (widget) widget.logout()
    }
  }
}
</script>